<script setup lang="ts">
const items = [
  {
    title: 'Koneksi Otomatis',
    description:
      'Hubungkan nomor WhatsApp bisnismu ke KiriminAja — cukup sekali, langsung aktif.',
    icon: 'material-symbols:connected-tv-outline'
  },
  {
    title: 'Pilih Skenario Pesan',
    description:
      'Kirim pesan otomatis di setiap tahap: pickup, on delivery, delivered, hingga review.',
    icon: 'material-symbols:monitor-outline'
  },
  {
    title: 'Sistem Kirim Real-Time',
    description:
      'Notifikasi dikirim otomatis ke pelanggan tetap terasa personal, tanpa intervensi manual.',
    icon: 'material-symbols:photo-size-select-small'
  }
]
</script>

<template>
  <section class="bg-surface-container-low dark:bg-surface-container-highest">
    <UiContainer class="py-12 flex flex-col gap-6 lg:gap-16">
      <UiSectionTitle
        class="text-center"
        title="Setiap Update Status, Otomatis Terkirim ke Pelanggan"
      />

      <div class="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <UiCardFeature
          v-for="(item, key) in items"
          :key="key"
          :icon="item.icon"
          icon-size="32px"
          :title="item.title"
          :description="item.description"
        />
      </div>
    </UiContainer>
  </section>
</template>
